// extracted by mini-css-extract-plugin
export default {"one":"SecOne_one__H0ly8","main":"SecOne_main__Ne+uk","gif":"SecOne_gif__vraSj"};